module.exports = __webpack_public_path__ + "static/media/quotes-white.03556c9a.svg";